import React from 'react';
import {FormattedMessage} from 'react-intl';
import Box from '../box/box.jsx';
import styles from './mobile-overlay.css';

const MobileOverlay = () => (
    <Box className={styles.overlay}>
        <Box className={styles.content}>
            <svg
                className={styles.icon}
                viewBox="0 0 24 24"
            >
                <path d="M20,18H4V4H20M20,2H4C2.89,2 2,2.89 2,4V18C2,19.1 2.9,20 4,20H9V22H15V20H20C21.11,20 22,19.1 22,18V4C22,2.89 21.1,2 20,2Z" />
            </svg>
            <div className={styles.title}>
                <FormattedMessage
                    defaultMessage="Desktop Mode Recommended"
                    description="Title for mobile device warning overlay"
                    id="gui.mobileOverlay.title"
                />
            </div>
            <div className={styles.message}>
                <FormattedMessage
                    defaultMessage="TIFStudio is best experienced on a desktop computer. Please switch to a desktop or laptop to use the full features of the editor."
                    description="Message for mobile device warning overlay"
                    id="gui.mobileOverlay.message"
                />
            </div>
            <div className={styles.desktopIcon}>
                <FormattedMessage
                    defaultMessage="Desktop Mode"
                    description="Label for desktop mode in mobile warning"
                    id="gui.mobileOverlay.desktop"
                />
            </div>
        </Box>
    </Box>
);

export default MobileOverlay;
